import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import ProfilePicture from "../UserProfile/ProfilePicture";
import { IoIosCloseCircle } from "react-icons/io";
import { deleteDoc, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { toastOptions } from "../lib/toastOptions";
import { toast } from "react-toastify";
import useChatClient from "../StatesStore/ChatClient";
import { Link } from "react-router-dom";
import { UserAuth } from "../Context";
import useModalStore from "../StatesStore/ModalStore";

const ManageMembers = ({
  closeTray,
  members,
  listId,
  listName,
  userId,
  setMemberDetails,
}) => {
  const { user } = UserAuth();
  const client = useChatClient((state) => state.client);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { openModal } = useModalStore();
  const handleClose = () => {
    closeTray();
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!client) {
    return null;
  }

  const handleRevokeUser = async (index, Id) => {
    console.log("handleRevokeUser", Id);
    const docRef = doc(
      db,
      "users",
      userId,
      "shoppingList",
      listName,
      "members",
      Id
    );
    const invitedListRef = doc(db, "users", Id, "invitedList", listId);
    const docSnap = await getDoc(docRef);
    const channel = client.channel("team", listId);
    await channel.removeMembers([Id]);
    handleClose();
    try {
      if (docSnap.exists) {
        // Remove the friend from the array
        await deleteDoc(docRef);
        await deleteDoc(invitedListRef);
        const newData = members?.filter((memeber) => memeber.id !== Id);
        setMemberDetails(newData);
        console.log("friendsData", newData);
        toast.success("User removed successfully!", toastOptions);
      }
      // await updateDoc(chatRef,{members:[...updatedMembers]})
    } catch (error) {
      console.error(error);
      toast.error("Error removing user!", toastOptions);
    }
  };
  const handleClickRemove = (friendData) => {
    const modalData = {
      userData: friendData,
      modalHeaderText: "Confirm Remove?",
      modalBodyText: () => {
        return (
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: "400",
              fontSize: "16px",
              letterSpacing: "0%",
              lineHeight: isSmallScreen ? "116%" : "146%",
              textAlign: isSmallScreen ? "center" : "left",
              verticalAlign: isSmallScreen ? "middle" : "",
              color: "#676A79",
            }}
          >
            Are you sure you want to remove{" "}
            <span
              style={{
                fontWeight: "500",
                color: "#000000",
              }}
            >
              {friendData?.userName}
            </span>
            ? This action cannot be undone.
          </div>
        );
      },
      handleConfirm: () => {
        handleRevokeUser("", friendData.id);
        handleClose();
      },
      confirmButtonText: "Remove",
    };
    openModal("RemoveFollowerFollowingModal", "user", modalData);
  };
  return (
    <>
      <div
        className="d-flex flex-column bg-white"
        style={{ marginTop: "12px", padding: "16px", borderRadius: "8px" }}
      >
        {members?.length > 0 ? (
          <>
            <div className="d-flex flex-column" style={{ gap: "16px" }}>
              {members.map((member, index) => (
                <div
                  key={member.id}
                  className="d-flex justify-content-between align-items-center w-100"
                  style={{ height: "40px" }}
                >
                  <Link
                    to={`/userProfile/${member?.id}`}
                    className="d-flex align-items-center"
                    style={{ gap: "8px" }}
                  >
                    <img
                      src={
                        member?.photo ||
                        `https://ui-avatars.com/api/?name=${member?.userName[0]?.toUpperCase()}`
                      }
                      loading="lazy"
                      width={"36px"}
                      height={"36px"}
                      style={{
                        borderRadius: "6px",
                        width: "36px",
                        height: "36px",
                        objectFit: "cover",
                        objectPosition: "top",
                      }}
                      alt=""
                    />
                    <div className="d-flex flex-column" style={{ gap: "4px" }}>
                      <div className="d-flex align-items-center gap-1">
                        <div
                          style={{
                            fontFamily: "Inter",
                            fontWeight: 500,
                            fontSize: "16px",
                            lineHeight: "100%",
                            letterSpacing: "0%",
                            color: "black",
                          }}
                        >
                          {member.userName}
                        </div>
                        {(member.role === "Owner" ||
                          member.id === user?.uid) && (
                          <div
                            style={{
                              fontFamily: "Inter",
                              fontWeight: 400,
                              fontSize: "12px",
                              lineHeight: "100%",
                              letterSpacing: "0%",
                              color: "#676A79",
                            }}
                          >
                            {member.id === user?.uid ? "You" : "Owner"}
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 400,
                          fontSize: "14px",
                          lineHeight: "100%",
                          letterSpacing: "0%",
                          color: "#676A79",
                        }}
                      >
                        {member?.userTitle?.trim()
                          ? member.userTitle.length > 28
                            ? `${member.userTitle.substring(0, 27)}...`
                            : member.userTitle
                          : "No Bio."}
                      </div>
                    </div>
                  </Link>
                  {userId === user?.uid && member.id !== user?.uid && (
                    <div
                      onClick={() => {
                        // console.log("data", data);
                        handleClickRemove(member);
                      }}
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        height: "30px",
                        width: "70px",
                        borderRadius: "8px",
                        backgroundColor: "#F4F9FF",
                        color: "#005FDA",
                      }}
                    >
                      Remove
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        ) : (
          <p className="text-center text-muted">No members found.</p>
        )}
      </div>
    </>
  );
};

export default ManageMembers;
